module.exports = __webpack_public_path__ + "img/tim-material-avatar-2-2x.91335f5c.png";